import { defineComponent as _defineComponent } from 'vue'
import JobStatusChip from '@/components/tickets/JobStatusChip.vue'
import { NO_APPROVAL, REQUESTED } from '@/models/job'
import { computed } from 'vue'
import { JobSearchResponse } from '@/models/types/job-search-response'

export default /*#__PURE__*/_defineComponent({
  __name: 'JobStatusCell',
  props: {
    value: { default: REQUESTED },
    job: null
  },
  setup(__props: any) {

const props = __props as { value: string, job: JobSearchResponse }


const finalStatus = computed(() => {
  const approvalStatus = props.job.approval_status ?? NO_APPROVAL
  return approvalStatus !== NO_APPROVAL ? approvalStatus : props.value.trim()
})

return { __sfc: true,props, finalStatus, JobStatusChip }
}

})